// extracted by mini-css-extract-plugin
export default {"properties":"XHPAW","propertiesRow":"nrolp"};